(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/betslip-footer.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/betslip-footer.js'); "use strict";

(function (Backbone, _, svs) {
  'use strict';

  svs.tipset.views.BetslipFooter = Backbone.Marionette.View.extend({
    template: function template(data) {
      return svs.tipset.templates.betslipfooter(data);
    },
    templateContext: function templateContext() {
      var ret = {};

      if (svs.tipset.models.play.get('isReduceMode')) {
        ret.reduceFreeMode = svs.tipset.models.play.get('isReduceMode');
        ret.rows = svs.tipset.models.reduceFreeContainer.get('rows');
        ret.possibleRows = svs.tipset.collections.matchlist.getNrOfRows();
      }

      return ret;
    },
    modelEvents: {
      change: 'onChange'
    },
    events: {
      'click #totalAmount': 'toggleOpen',
      'click .betslip-footer-tag': 'toggleOpen'
    },
    className: 'betslip-footer-tipsen row',
    log: new svs.core.log.Logger('svs.tipset.views.BetslipFooter'),
    initialize: function initialize() {
      this.uid = svs.tipset.getUid();
      this.$el.addClass("betslip-footer-".concat(svs.tipset.models.gameDefinitions.get('htmlClass')));
      this.wasValid = this.model && this.model.get('isPayable');
      this.listenTo(svs.tipset.models.play, 'change', this.render);
      this.listenTo(svs.tipset.models.reduceFreeContainer, 'change:rows', this.render);
      this.listenTo(svs.tipset.collections.matchlist, 'buttonBet', this.render);
    },
    onChange: function onChange() {
      this.render();

      if (!this.wasValid && this.model.get('isPayable')) {
        svs.tipset.views.betslip.validBetslip({
          tracking: svs.tipset.models.gameDefinitions.get('productName') === svs.tipset.constants.PRODUCTNAME.STRYKTIPSET,
          productName: svs.tipset.models.gameDefinitions.get('productName')
        });
      }

      this.wasValid = this.model.get('isPayable');
    },
    onDestroy: function onDestroy() {
      this.undelegateEvents();
      this.stopListening();

      if (svs.components.marketplace && svs.components.marketplace.accountSelector && svs.components.marketplace.accountSelector.helpers) {
        svs.components.marketplace.accountSelector.helpers.observer.unsubscribe(this.marketplaceTag);
      }
    },
    marketplaceTag: function marketplaceTag(_ref) {
      var currentAccount = _ref.currentAccount;

      if (currentAccount) {
        svs.tipset.views.betslip.showBetslipTag(currentAccount.name);
      } else {
        svs.tipset.views.betslip.hideBetslipTag();
      }
    },
    onRender: function onRender() {
      var marketplace = svs.components.marketplace;

      if (window.location.href.indexOf('tipssm') > -1) {
        if (svs.utils.ns.isNamespace('svs.competition.core.data.canPlayTipsSM') && svs.competition.core.data.canPlayTipsSM && svs.competition.Helper && svs.competition.Helper.userIsParticipatingInTipsSM()) {
          svs.tipset.views.betslip.showBetslipTag('Tips-SM');
          $('.betslip-footer-tag').addClass("betslip-footer-tag-".concat(svs.tipset.models.gameDefinitions.get('htmlClass')));
        }
      } else if (marketplace && marketplace.accountSelector) {
        var account = marketplace.accountSelector.helpers.getCurrentAccount();

        if (account) {
          if (svs.tipset.views.betslip) {
            svs.tipset.views.betslip.showBetslipTag(marketplace.accountSelector.helpers.getCurrentAccount().name);
          }
        } else if (svs.components.marketplace.accountSelector.helpers) {
          if (!this.isSubscribedToAccountSelector) {
            svs.components.marketplace.accountSelector.helpers.observer.subscribe(this.marketplaceTag);
            this.isSubscribedToAccountSelector = true;
          }

          if (svs.tipset.views.betslip) {
            svs.tipset.views.betslip.hideBetslipTag();
          }
        } else {
          if (svs.tipset.views.betslip) {
            svs.tipset.views.betslip.hideBetslipTag();
          }
        }
      } else {
        if (svs.tipset.views.betslip) {
          svs.tipset.views.betslip.hideBetslipTag();
        }
      }
    }
  });
})(Backbone, _, svs);
 })(window);